import ActiveCampaign from "./pages/Activecampaign";
import Aweber from "./pages/Aweber";
import "./autoresponder.scss";
import useHttp from "../../../hooks/use-http";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";
import { settingAction } from "../../../store/setting-store";
import MailChimp from "./pages/Mailchimp";
import GetResponse from "./pages/GetResponse";
const Autoresponder = () => {
  const { sendRequest } = useHttp();
  const dispatch = useDispatch();
  const is_autoresponder_loaded = useSelector(
    (state) => state.settings.is_autoresponder_loaded
  );
  
 
  useEffect(() => {
    // console.log(is_autoresponder_loaded);
    if (!is_autoresponder_loaded) {
      sendRequest(
        {
          url: endPoints.fetchAllKeys,
          method: "GET",
        },
        (response) => {
          dispatch(
            settingAction.setAutoresponder({ autoresponder: response.body })
          );

          dispatch(settingAction.setAutoresponderStatus({ status: true }));
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [is_autoresponder_loaded]);

  return (
    <>
      <div className="col-md-12 mb-4 autoresponder">
        <div className="bx_a">
          <h5 className="mb-4 small_title d-flex">AutoResponder Setting</h5>
          <p>
            Choose your email autoresponders on the list below and set them up
            with the correct settings for smooth and efficient VidCraft AI
            functionality. Check with your autoresponders for precise
            information for an error-free VidCraft AI integration.
          </p>

          <nav className="mt-2 d-flex  justify-content-center ">
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                className="nav-link active"
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-aweber"
                type="button"
                role="tab"
                aria-controls="nav-aweber"
                aria-selected="true"
              >
                <i>
                  {" "}
                  <img
                    src="https://breezefunnels.net/app/assets/images/ic17.png"
                    alt="aweber"
                  />
                </i>
                Aweber
              </button>
              <button
                className="nav-link "
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-getResponse"
                type="button"
                role="tab"
                aria-controls="nav-getResponse"
                aria-selected="true"
              >
                <i>
                  {" "}
                  <img
                    src="https://breezefunnels.net/app/assets/images/ic19.png"
                    alt="aweber"
                  />
                </i>
                Get Response
              </button>
              <button
                className="nav-link "
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-mailchimp"
                type="button"
                role="tab"
                aria-controls="nav-mailchimp"
                aria-selected="true"
              >
                <i>
                  {" "}
                  <img
                    src="https://breezefunnels.net/app/assets/images/ic18.png"
                    alt="aweber"
                  />
                </i>
                Mailchimp
              </button>
              <button
                className="nav-link "
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-activecampaign"
                type="button"
                role="tab"
                aria-controls="nav-activecampaign"
                aria-selected="true"
              >
                <i>
                  {" "}
                  <img
                    src="https://breezefunnels.net/app/assets/images/ic22.png"
                    alt="aweber"
                  />
                </i>
                Active Campaign
              </button>
            </div>
          </nav>

          <div
            className="tab-content d-flex align-items-center"
            id="nav-tabContent"
          >
            <div
              className="tab-pane m_t_8 text-center fade show active"
              id="nav-aweber"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="card">
                <div className="card-body">
                  <h6>Manage Your Aweber Account</h6>
                  <Aweber />
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade m_t_8"
              id="nav-getResponse"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="card">
                <div className="card-body">
                  <h6>Manage Your Getresponse Account</h6>
                  <GetResponse />
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade m_t_8"
              id="nav-mailchimp"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="card">
                <div className="card-body">
                  <h6>Manage Your Mailchimp Account</h6>
                  <MailChimp />
                </div>
              </div>
            </div>
            <div
              className="tab-pane fade m_t_8"
              id="nav-activecampaign"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="card">
                <div className="card-body">
                  <h6>Manage Your ActiveCampaign Account</h6>
                  <ActiveCampaign />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Autoresponder;
